module.exports = __webpack_public_path__ + "img/Poser.9495f55d.svg";